import * as DashboardConstants from '.././DashboardConstants';

export const juniperTicketsData = [
    {
        "group": "Dataset 1",
        "date": "2018-12-31T18:30:00.000Z",
        "value": 500,
    },
    {
        "group": "Dataset 1",
        "date": "2018-12-30T18:30:00.000Z",
        "value": 200,
        "surplus": 1020724329.3001977
    },
    {
        "group": "Dataset 2",
        "date": "2018-12-1T18:30:00.000Z",
        "value": 100,
        "surplus": 1020724329.3001977
    },
    {
        "group": "Dataset 1",
        "date": "2018-12-2T18:30:00.000Z",
        "value": 200,
        "surplus": 1020724329.3001977
    }
];

export const reportTableHeaders = [
    {
        key: 'incidentId',
        header: DashboardConstants.IncidentId,
        hidden: false,
        optional: false
    },
    {
        key: 'priority',
        header: DashboardConstants.Priority,
        hidden: false,
        optional: false
    },
    {
        key: 'summary',
        header: DashboardConstants.Summary,
        hidden: false,
        optional: false
    },
    {
        key: 'description',
        header: DashboardConstants.Description,
        hidden: false,
        optional: false
    },
    {
        key: 'ticketType',
        header: DashboardConstants.TicketType,
        hidden: false,
        optional: false
    },
    {
        key: 'rootCause',
        header: DashboardConstants.RootCause,
        hidden: false,
        optional: false
    },
    {
        key: 'category',
        header: DashboardConstants.Category,
        hidden: false,
        optional: false
    },
    {
        key: 'assignmentGroup',
        header: DashboardConstants.AssignmentGroup,
        hidden: false,
        optional: false
    },
    {
        key: 'createdDate',
        header: DashboardConstants.CreatedDate,
        hidden: false,
        optional: false
    },
    {
        key: 'createdTime',
        header: DashboardConstants.CreatedTime,
        hidden: false,
        optional: false
    },
    {
        key: 'client',
        header: DashboardConstants.Client,
        hidden: false,
        optional: false
    },
    {
        key: 'actionedBySME',
        header: DashboardConstants.ActionedbySME,
        hidden: false,
        optional: false
    },
    // {
    //     key: 'changedResolutionSteps',
    //     header: DashboardConstants.ChangedResolutionSteps,
    //     hidden: false,
    //     optional: false
    // },
    // {
    //     key: 'changedRootCause',
    //     header: DashboardConstants.ChangedRootCause,
    //     hidden: false,
    //     optional: false
    // },
    {
        key: 'changedAssignmentGroup',
        header: DashboardConstants.ChangedAssignmentGroup,
        hidden: false,
        optional: false
    }
];

export const predictionReportHeaders = [
    {
        key: 'incidentId',
        header: DashboardConstants.IncidentId,
        hidden: false,
        optional: false
    },
    {
        key: 'priority',
        header: DashboardConstants.Priority,
        hidden: false,
        optional: false
    },
    {
        key: 'summary',
        header: DashboardConstants.Summary,
        hidden: false,
        optional: false
    },
    {
        key: 'snowCategory',
        header: DashboardConstants.SnowCategory,
        hidden: false,
        optional: false
    },
    {
        key: 'snowAssignmentGroup',
        header: DashboardConstants.SnowAssignmentGroup,
        hidden: false,
        optional: false
    },
    {
        key: 'predictedCategory',
        header: DashboardConstants.PredictedCategory,
        hidden: false,
        optional: false
    },
    {
        key: 'predictedAssignementGroup',
        header: DashboardConstants.PredictedAssignmentGroup,
        hidden: false,
        optional: false
    },
    {
        key: 'matchCategory',
        header: DashboardConstants.MatchCategory,
        hidden: false,
        optional: false
    },
    {
        key: 'matchAssignmentGroup',
        header: DashboardConstants.MatchAssignmentGroup,
        hidden: false,
        optional: false
    },
    {
        key: 'createdDate',
        header: DashboardConstants.CreatedDate,
        hidden: false,
        optional: false
    },
    {
        key: 'closureDate',
        header: DashboardConstants.ClosureDate,
        hidden: false,
        optional: false
    },
    {
        key: 'actionedBySME',
        header: DashboardConstants.ActionedbySME,
        hidden: false,
        optional: false
    },
];

export const sampleReportData = [
    {
        id: '1',
        incidentId: "INC3782345",
        priority: 'P4 - Service request',
        summary: 'Comparison Result EXCHANGE',
        snowCategory: 'Application support',
        snowAssignmentGroup: 'IT-SAP-JOB-MONITORING',
        predictedCategory: 'Application support',
        predictedAssignementGroup: 'IT-SAP-JOB-MONITORING',
        matchAssignmentGroup: 'TRUE',
        createdDate: '2021-12-22T15:06:15.000Z',
        closureDate: '2021-12-27T15:06:16.000Z',
        actionedBySME: 'N',
    },
    {
        id: '2',
        incidentId: "INC3784476",
        priority: 'P3 - Normal',
        summary: 'Comparison Result EQUIPMENT',
        snowCategory: 'Application support',
        snowAssignmentGroup: 'IT-SAP-JOB-MONITORING',
        predictedCategory: 'Application support',
        predictedAssignementGroup: 'IT-SAP-ITR-JOBS-FAILURE',
        matchCategory: 'TRUE',
        matchAssignmentGroup: 'FALSE',
        createdDate: '2021-12-26T16:20:46.000Z',
        closureDate: '2021-12-26T16:20:46.000Z',
        actionedBySME: 'N',
    },
    {
        id: '3',
        incidentId: "INC3783343",
        priority: 'P3 - Normal',
        summary: 'Need I137 XML file for PO 4500564600 - Update',
        snowCategory: 'Application support',
        snowAssignmentGroup: 'IT-SAP-SCM-SUPPORT',
        predictedCategory: 'Other Issues',
        predictedAssignementGroup: 'IT-SAP-SCM-SUPPORT',
        matchCategory: 'FALSE',
        matchAssignmentGroup: 'TRUE',
        createdDate: '2021-12-23T22:38:08.000Z',
        closureDate: '2021-12-23T22:38:12.000Z',
        actionedBySME: 'N',
    },
]


export const juniperReportData = [
    {
        id: '1',
        incidentId: 270411,
        priority: 'P4 - Service request',
        summary: 'Request access to Public Folders -> SRM  Advanced…',
        description: 'I was told that new report for Advanced Services and…',
        ticketType: 'Service request',
        rootCause: 'User Access',
        category: 'Application support',
        assignmentGroup: 'IT-SAP-BI',
        runbookSuggestion: '-'

    },
    {
        id: '2',
        incidentId: 453215,
        priority: 'P3 - Normal',
        summary: 'Unable to generate Outbound DN',
        description: 'Hi Team,Kindly note we are unable to generate Outbo…',
        ticketType: 'Service request',
        rootCause: 'User Access',
        category: 'Application support',
        assignmentGroup: 'IT-SAP-BI',
        runbookSuggestion: '-'

    },
    {
        id: '3',
        incidentId: 987878,
        priority: 'P4 - Service request',
        summary: 'Intermittent Issue with FCO Cost Rollup!',
        description: 'some of the users are getting nUll pointer exception.',
        ticketType: 'Service request',
        rootCause: 'User Access',
        category: 'Application support',
        assignmentGroup: 'IT-SAP-BI',
        runbookSuggestion: '-'

    },
    {
        id: '4',
        incidentId: 657867,
        priority: 'P4 - Service request',
        summary: 'Can\'t access to SFDC TAC Escalation tool and got error…',
        description: 'Can\'t access to SFDC TAC Escalation tool and got error…',
        ticketType: 'Service request',
        rootCause: 'User Access',
        category: 'Application support',
        assignmentGroup: 'IT-SAP-BI',
        runbookSuggestion: '-'

    },
    {
        id: '5',
        incidentId: 123243,
        priority: 'P4 - Service request',
        summary: 'Access to SAP CRM',
        description: 'Hi Satish, Could you please provide me the access to…',
        ticketType: 'Service request',
        rootCause: 'User Access',
        category: 'Application support',
        assignmentGroup: 'IT-SAP-BI',
        runbookSuggestion: '-'

    },
    {
        id: '6',
        incidentId: 765643,
        priority: 'P4 - Service request',
        summary: 'Unbale to view the partner user',
        description: 'Hi Team, Please help to fix  the bellow record as the user…',
        ticketType: 'Service request',
        rootCause: 'User Access',
        category: 'Application support',
        assignmentGroup: 'IT-SAP-BI',
        runbookSuggestion: '-'

    }
]